import React from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Pencil } from "lucide-react";

export default function FloatingEditButton({ slug, href }) {
    const { user } = useAuth();

  if (!user || user.role !== "admin") return null;

  // FIX: guard si no hay destino válido
  if (!slug && !href) return null;

  const to = href || (slug === "home" ? "/admin/portada" : `/admin/paginas/${slug}`);
    const label = slug || href;

  // Portal a document.body: como este botón se pinta dentro de <PageTransition>
  // (cada página lo monta desde su propio componente), el `transform` residual
  // que deja esa animación de entrada lo convertía en el bloque de contención
  // de este `position:fixed` — con la página desplazada, el botón aparecía
  // fuera de la esquina donde debía estar en vez de fijo respecto al
  // viewport. Mismo problema que la barra flotante de PageHero.js y el modal
  // de inscripción, mismo arreglo.
  return createPortal(
        <Link
        to={to}
        data-testid="floating-edit-btn"
        title={`Editar página "${label}"`}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 px-5 py-3 rounded-full text-white font-semibold text-sm shadow-2xl transition-all hover:scale-105 hover:shadow-blue-500/40"
      style={{
                background: "linear-gradient(135deg, #1868C2 0%, #0E4E99 100%)",
                boxShadow: "0 8px 32px rgba(14, 78, 153, 0.4)",
      }}
    >
      <Pencil className="w-4 h-4" />
            Editar página
      </Link>,
    document.body
  );
}
